module.exports = __webpack_public_path__ + "img/111.7.aadcee6e.png";